$(document).ready(function () {
    //Range Picker for start date
    if (document.getElementById('start-date')){
        new Lightpick({
            field: document.getElementById('start-date'),
            lang: 'en',
            format: 'DD/MM/YYYY',
            startDate: new Date(new Date().getFullYear(),new Date().getMonth() - 1, 1)
        });
    }

    //Range Picker for end date
    if (document.getElementById('end-date')) {
        new Lightpick({
            field: document.getElementById('end-date'),
            lang: 'en',
            format: 'DD/MM/YYYY',
            startDate: new Date(new Date().getFullYear(),new Date().getMonth(), 0)
        });
    }

    //Get converted data then save
    $(document).on('click', '#invoice-export-run', function (e) {
        e.preventDefault();

        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let form = $('#invoice-export-run-form');
        let action = form.attr('action');
        let formData = {
            start_date: form.find("#start-date").val(),
            end_date: form.find("#end-date").val(),
        };

        $.ajax({
            url : action,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.success) {
                    $('#invoice-export-download-errors').hide();

                    let table = $('#invoice-export-table');
                    let thead = $('<thead></thead>');
                    let tbody = $('<tbody></tbody>');

                    let tr = $('<tr></tr>');
                    for (let i = 0; i < data.header.length; i++){
                        tr.append($('<th>' + data.header[i] + '</th>'));
                    }
                    thead.append(tr);

                    for (let i = 0; i < data.rows.length; i++){
                        let tr = $('<tr></tr>');
                        tr.append($('<td>' + data.rows[i]['Date Start'] + '</td>'));
                        tr.append($('<td>' + data.rows[i]['Date End'] + '</td>'));
                        tr.append($('<td>' + data.rows[i]['Client'] + '</td>'));
                        tr.append($('<td>' + data.rows[i]['Market'] + '</td>'));
                        tr.append($('<td>' + data.rows[i]['Rate Gross'] + '</td>'));
                        tbody.append(tr);
                    }

                    table.html('');
                    table.append(thead);
                    table.append(tbody);
                    table.removeClass('d-none');

                    $('#invoice-export-data').val(JSON.stringify({
                        header: data.header,
                        rows: data.rows
                    }));

                    $('#invoice-export-download').removeClass('d-none');
                } else {
                    $('#invoice-export-download-errors').html(data.errors.join('<br>')).fadeIn();

                    let table = $('#invoice-export-table');
                    if(!table.hasClass('d-none')){
                        table.addClass('d-none');
                    }

                    table.html('');

                    $('#invoice-export-data').val('');

                    let download = $('#invoice-export-download');
                    if(!download.hasClass('d-none')){
                        download.addClass('d-none');
                    }
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function() {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).on('click', '#invoice-export-download', function (e) {
        e.preventDefault();
        $('#invoice-export-download-form').submit();
    });
});
